export const EKybStatus = {
  Approved: "Approved",
  Pending: "Pending",
  NeedsReview: "Needs review",
  NotStarted: "Not started",
  Rejected: "Rejected",
} as const;

export type EKybStatus = (typeof EKybStatus)[keyof typeof EKybStatus];
